import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import DateTime from '_class/DateTime';
import ColorScale from '_class/ColorScale';
import { getRootUrl } from 'helpers/url';
import { getSectionAssessmentStatistics } from 'actions/sections';
import { Spinner, Collapsible } from 'UI';
import { Bar, Progress } from 'UI/Graphs';
import { Block, Button, Checkbox, Expandable, Icon, MultiSelect, Table, translate } from '@haldor/ui';
import './UserSection.scss';

var UserSection = /*#__PURE__*/function (_Component) {
  _inherits(UserSection, _Component);

  var _super = _createSuper(UserSection);

  function UserSection(props) {
    var _this;

    _classCallCheck(this, UserSection);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_setContainer", function (element) {
      return _this.container = element;
    });

    _defineProperty(_assertThisInitialized(_this), "_setBarColumn", function (element) {
      return _this.barColumn = element;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      window.addEventListener('hashchange', _this.onHashChange);
      window.addEventListener('resize', _this.resize);

      _this.setState({
        openStudents: _this.props.section.students.map(function (student) {
          return student.userId;
        })
      }, function () {
        _this.resize();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      window.removeEventListener('resize', _this.resize);
      window.removeEventListener('hashchange', _this.onHashChange);
    });

    _defineProperty(_assertThisInitialized(_this), "onHashChange", function () {
      if (window.location.hash == '#assessments') {
        _this.setState({
          showMenu: true
        });
      } else {
        _this.setState({
          showMenu: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "resize", function () {
      if (_this.barColumn != null && _this.container != null) {
        _this.setState({
          width: _this.container.scrollWidth - _this.barColumn.scrollWidth
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleStudentOpen", function (student) {
      var index = _this.state.openStudents.indexOf(student.userId);

      if (index > -1) {
        _this.setState({
          openStudents: _this.state.openStudents.filter(function (id) {
            return id != student.userId;
          })
        });
      } else {
        _this.setState({
          openStudents: [].concat(_toConsumableArray(_this.state.openStudents), [student.userId])
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleStudentsOpen", function () {
      var active = _this.props.section.students.length == _this.state.openStudents.length;

      if (active) {
        _this.setState({
          openStudents: []
        });
      } else {
        _this.setState({
          openStudents: _this.props.section.students.map(function (student) {
            return student.userId;
          })
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleFilter", function (filter) {
      var index = _this.state.filters.indexOf(filter);

      if (index > -1) {
        _this.setState({
          filters: _this.state.filters.filter(function (id) {
            return id != filter;
          })
        });
      } else {
        _this.setState({
          filters: [].concat(_toConsumableArray(_this.state.filters), [filter])
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSubjectsChange", function (subjects) {
      _this.setState({
        subjects: subjects
      });

      var _this$props = _this.props,
          section = _this$props.section,
          start = _this$props.start,
          end = _this$props.end;

      _this.setState({
        loadingAssessments: true
      });

      _this.props.getSectionAssessmentStatistics(section.id, start, end, subjects).then(function (response) {
        _this.setState({
          loadingAssessments: false
        });
      })["catch"](function (e) {
        _this.setState({
          loadingAssessments: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getPercentageFromStatistics", function (items) {
      if (items == null) {
        return 0;
      }

      var percentages = [];
      items.forEach(function (item) {
        var item_total = 0;
        var indexed = [];
        item.statistics.forEach(function (stat) {
          item_total += stat.count;
          indexed.push({
            count: stat.count,
            index: stat.index,
            weight: stat.weight
          });
        });

        for (var i = 0; i <= item_total; i++) {
          indexed.map(function (entry) {
            if (entry.count > 0) {
              percentages.push(entry.weight);
              entry.count = entry.count - 1;
            }

            return entry;
          });
        }
      });
      return Math.round(percentages.reduce(function (a, b) {
        return a + b;
      }, 0) / percentages.length);
    });

    _defineProperty(_assertThisInitialized(_this), "renderAssessmentBar", function (item, index) {
      if (!_this.state.filters.includes(item.type)) {
        return null;
      }

      if (item.statistics != null) {
        var data = [];
        var isEmpty = item.statistics.find(function (stat) {
          return stat.count > 0;
        }) == null;

        if (isEmpty) {
          return null;
        }

        var colors = new ColorScale(item.statistics.length).get();
        item.statistics.map(function (stat) {
          data.push({
            amount: stat.count,
            label: stat.count,
            color: colors[stat.index]
          });
        });
        var line = null;

        if (data.length > 0) {
          line = /*#__PURE__*/React.createElement(Bar, {
            data: data,
            showAmount: true,
            showAllSteps: true
          });
        }

        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "bar-outer-container"
        }, /*#__PURE__*/React.createElement("div", null, _this.props.translate(item.type)), line);
      }

      return /*#__PURE__*/React.createElement("div", null);
    });

    _defineProperty(_assertThisInitialized(_this), "getChildHistoricMembers", function (historicMember) {
      var children = _this.props.section.historicMembers.filter(function (el) {
        return el.userId == historicMember.userId && el.relationship == 'child';
      });

      return children.map(function (member, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "history-member-row child"
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          },
          className: "name"
        }), /*#__PURE__*/React.createElement("div", {
          className: "connected-duration"
        }, /*#__PURE__*/React.createElement("span", null, "".concat(new DateTime(member.startDate).getDateStamp(), " - ").concat(new DateTime(member.endDate).getDateStamp())), member.userRoles.some(function (el) {
          return el == 'OWNER';
        }) ? /*#__PURE__*/React.createElement("div", {
          className: "card-meta",
          style: {
            marginLeft: '1.65rem',
            fontWeight: 500
          }
        }, _this.props.translate('Owner')) : null));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderStudentRoleIndicator", function (student) {
      if (student == null) {
        return null;
      }

      if (student.userRoles != null && student.userRoles.indexOf('STUDENT') == -1) {
        var _translate = _this.props.translate;
        return /*#__PURE__*/React.createElement(Icon, {
          name: "Alert_Red",
          title: _translate('Missing student role in school')
        });
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderGoalBar", function () {
      var percentage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (!_this.state.filters.includes('ASSESSMENTGOAL')) {
        return null;
      }

      if (percentage == 0) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "bar-outer-container"
      }, /*#__PURE__*/React.createElement("div", null, _this.props.translate('ASSESSMENTGOAL')), /*#__PURE__*/React.createElement("div", {
        style: {
          paddingLeft: '.55rem'
        }
      }, /*#__PURE__*/React.createElement(Progress, {
        percentage: percentage,
        label: "".concat(percentage, "%")
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderTable", function () {
      var width = _this.state.width > 0 ? _this.state.width + 'px' : '100%';

      var sortedStudents = _this.props.section.students.sort(function (a, b) {
        return a.lastName.localeCompare(b.lastName);
      }); // return (<div>
      // 	{sortedStudents.map((student) => {
      // 		let studentName = student.firstName + " " + student.lastName;
      // 		console.log(studentName);
      // 		return (<Expandable title={studentName} onChange={() => this.toggleStudentOpen(student)} open={open}></Expandable>)
      // 	})}
      // </div>);


      return /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
        ref: _this._setBarColumn
      }, _this.props.translate('name')), /*#__PURE__*/React.createElement("th", {
        style: {
          width: width
        }
      }, _this.props.translate('assessment-overview')))), /*#__PURE__*/React.createElement("tbody", null, sortedStudents.map(function (student) {
        var _this$props$sectionAs;

        var assessments = null;
        var percentage = 0;

        var open = _this.state.openStudents.includes(student.userId);

        if (((_this$props$sectionAs = _this.props.sectionAssessmentStatistics) === null || _this$props$sectionAs === void 0 ? void 0 : _this$props$sectionAs.data) != null) {
          var _assessments, _assessments$studentS;

          var statistics = _this.props.sectionAssessmentStatistics.data;
          assessments = statistics.find(function (assessment) {
            return assessment.studentId == student.userId;
          });
          var goalStatistics = (_assessments = assessments) === null || _assessments === void 0 ? void 0 : (_assessments$studentS = _assessments.studentStatistics) === null || _assessments$studentS === void 0 ? void 0 : _assessments$studentS.filter(function (stat) {
            return stat.type == 'ASSESSMENTGOAL';
          });
          percentage = _this.getPercentageFromStatistics(goalStatistics);
        }

        var studentName = student.firstName + " " + student.lastName;
        console.log(studentName);
        return /*#__PURE__*/React.createElement("tr", {
          key: student.id
        }, /*#__PURE__*/React.createElement("td", {
          className: "name",
          title: "".concat(_this.props.translate('Connected to group'), " ").concat(new DateTime(student.connectedToSectionDate).getDateStamp())
        }, /*#__PURE__*/React.createElement(Link, {
          to: "".concat(getRootUrl(), "groups/").concat(_this.props.section.id, "/progress/").concat(student.id)
        }, _this.renderStudentRoleIndicator(student), student.firstName, " ", student.lastName)), /*#__PURE__*/React.createElement("td", {
          className: "assessment-bar"
        }, /*#__PURE__*/React.createElement(Expandable, {
          title: "'title'",
          onChange: function onChange() {
            return _this.toggleStudentOpen(student);
          },
          open: open
        }, percentage > 0 ? _this.renderGoalBar(percentage) : null, assessments != null ? assessments.studentStatistics.map(function (item, index) {
          if (item.type == 'MATRIX') {
            return _this.renderAssessmentBar(item, index);
          }

          return null;
        }) : /*#__PURE__*/React.createElement("div", {
          style: {
            height: 23
          }
        }))));
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderExpand", function () {
      var active = _this.props.section.students.length == _this.state.openStudents.length;
      return /*#__PURE__*/React.createElement("div", {
        className: active ? 'expand-all active' : 'expand-all',
        onClick: _this.toggleStudentsOpen
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "ArrowLeft"
      }), " ", active ? _this.props.translate('Close all') : _this.props.translate('Show all'));
    });

    _this.state = {
      filters: ['ASSESSMENTGOAL', 'MATRIX'],
      subjects: [],
      openStudents: [],
      loadingAssessments: false,
      width: 0,
      showMenu: true
    };
    _this.container = null;
    _this.barColumn = null;
    return _this;
  }

  _createClass(UserSection, [{
    key: "render",
    value: function render() {
      var _this$props$section$h,
          _this2 = this,
          _this$props$section$h2;

      (_this$props$section$h = this.props.section.historicMembers) === null || _this$props$section$h === void 0 ? void 0 : _this$props$section$h.forEach(function (member, index) {
        var laterEntries = _this2.props.section.historicMembers.some(function (el, someIndex) {
          return el.userId == member.userId && someIndex > index;
        });

        var earlierEntries = _this2.props.section.historicMembers.some(function (el, someIndex) {
          return el.userId == member.userId && someIndex < index;
        });

        if (laterEntries && !earlierEntries) {
          member.relationship = 'parent';
        } else if (laterEntries && earlierEntries || !laterEntries && earlierEntries) {
          member.relationship = 'child';
        } else {
          member.relationship = null;
        }
      });
      var subjects = this.props.subjects;

      if (subjects != null && subjects.find(function (subject) {
        return subject.id == 0;
      }) == null) {
        subjects.push({
          id: 0,
          title: this.props.translate('Assessments without subjects')
        });
      }

      if (subjects != null) {
        console.log(subjects.map(function (subject) {
          return {
            label: subject.title,
            value: subject.id
          };
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        ref: this._setContainer,
        className: "list user-mentor"
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("div", {
        className: "title-container"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title",
        style: {
          marginBottom: 0
        }
      }, this.props.translate('Students')), this.state.showMenu ? /*#__PURE__*/React.createElement("div", {
        className: "filter-container"
      }, this.state.loadingAssessments ? /*#__PURE__*/React.createElement(Spinner, {
        small: true
      }) : null, /*#__PURE__*/React.createElement(Checkbox, {
        label: this.props.translate('MATRIX'),
        onChange: function onChange() {
          return _this2.toggleFilter('MATRIX');
        },
        value: this.state.filters.includes('MATRIX')
      }), /*#__PURE__*/React.createElement(Checkbox, {
        label: this.props.translate('ASSESSMENTGOAL'),
        onChange: function onChange() {
          return _this2.toggleFilter('ASSESSMENTGOAL');
        },
        value: this.state.filters.includes('ASSESSMENTGOAL')
      }), subjects != null ? /*#__PURE__*/React.createElement(MultiSelect, {
        displaySelectedCount: false,
        trigger: this.props.translate('Showing') + ' ' + this.state.subjects.length + ' ' + this.props.translate('of') + ' ' + subjects.length,
        options: subjects.map(function (subject) {
          return {
            label: subject.title,
            value: subject.id
          };
        }),
        value: subjects.map(function (subject) {
          return subject.id;
        }),
        onChange: this.onSubjectsChange,
        selectAllLabel: this.props.translate('Select all')
      }) : null, this.renderExpand()) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          margin: '0 -1.7rem'
        }
      }, this.renderTable()), this.props.section.historicMembers && this.props.section.historicMembers.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "previous-members-card"
      }, /*#__PURE__*/React.createElement(Collapsible, {
        trigger: /*#__PURE__*/React.createElement("div", {
          className: "previous-members-title"
        }, this.props.translate('Previous members'))
      }, /*#__PURE__*/React.createElement("div", {
        className: "previous-member-list"
      }, (_this$props$section$h2 = this.props.section.historicMembers) === null || _this$props$section$h2 === void 0 ? void 0 : _this$props$section$h2.map(function (student, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: index
        }, student.relationship == 'parent' ? /*#__PURE__*/React.createElement(Collapsible, {
          trigger: /*#__PURE__*/React.createElement("div", {
            className: "history-member-row"
          }, /*#__PURE__*/React.createElement("div", {
            className: "name"
          }, student.displayName), /*#__PURE__*/React.createElement("div", {
            className: "connected-duration"
          }, /*#__PURE__*/React.createElement("span", null, "".concat(new DateTime(student.startDate).getDateStamp(), " - ").concat(new DateTime(student.endDate).getDateStamp())), student.userRoles.some(function (el) {
            return el == 'OWNER';
          }) ? /*#__PURE__*/React.createElement("div", {
            className: "card-meta",
            style: {
              marginLeft: '1.65rem',
              fontWeight: 500
            }
          }, _this2.props.translate('Owner')) : null))
        }, _this2.getChildHistoricMembers(student)) : student.relationship == null ? /*#__PURE__*/React.createElement("div", {
          className: "history-member-row child"
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          },
          className: "name"
        }, student.displayName), /*#__PURE__*/React.createElement("div", {
          className: "connected-duration"
        }, "".concat(new DateTime(student.startDate).getDateStamp(), " - ").concat(new DateTime(student.endDate).getDateStamp()))) : null);
      }))))));
    }
  }]);

  return UserSection;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    sectionAssessmentStatistics: state.sections.sectionAssessmentStatistics
  };
}

export default connect(mapStateToProps, {
  getSectionAssessmentStatistics: getSectionAssessmentStatistics
})(UserSection);